import { Env } from '../../../env'
import { useTranslation } from 'react-i18next'

/** Same rules as `useCurrency`, for use outside hooks (pass `t` from `useTranslation('tiers')`). */
export function formatCurrencyAmount(
  t: (key: string, options?: { price: string }) => string,
  amount: number
): string {
  const price = amount.toFixed(2)
  return Env.IS_CN ? t('rmb', { price }) : t('dollar', { price })
}

export const useCurrency = (amount: number) => {
  const { t } = useTranslation('tiers')
  return formatCurrencyAmount(t, amount)
}
